import styled from 'styled-components'
// @ts-ignore
import { Card } from 'reactstrap'
import { IconTrash } from '@tabler/icons-react'

export const ContentWrapper = styled.div`
  max-width: 35vw;
  height: 100%;
`

export const StyledCard = styled.div`
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.2);
  background: var(--surface-elevated);
  margin: 0 2rem;
`

export const Main = styled.div`
  width: -webkit-fill-available;
  height: 100%;
  background: linear-gradient(var(--color-primary) 200px, var(--surface-bg) 200px);
  display: flex;
  flex-direction: column;
`
export const Header = styled.h3`
  color: white !important;
`
export const CardBody = styled(Card)`
  background: var(--surface-bg);
`

export const Image = styled.img`
  width: 60px;
  height: 42px;
  margin-right: 1rem;
  border-radius: 5px;
`

export const ImgContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: -webkit-fill-available;
  padding: 0.5rem;
`

export const DeleteIcon = styled(IconTrash)`
  color: var(--color-danger);
`
